import React, { PureComponent } from 'react'
import SModal from 'components/sModal'
import SButton from 'components/sButton'
import { saveCoinToDB } from 'actions/coins'
import { connect } from 'react-redux'
import './styles.css'
import _ from 'lodash'

import coinsExtended from 'selectors/coinsExtended'

class EditCoinPopup extends PureComponent {
  constructor(props){
    super(props)

    const coin = this.getCoin()
    this.coinProps = _.uniq([
      ...Object.keys(coin),
      ...[ 'name', 'symbol', 'apiSymbol', 'twitter', 'reddit', 'telegram', 'medium', 'bitcointalk', 'website', 'discord', 'searchName']
    ]).sort();

    this.state = this.coinProps.reduce(
      (acc, val ) => (
        { ...acc,
          [val]: coin[val] || '' ,
          deletedPast: coin.deletedPast || {},
          skips: coin.skips || {}
        }) ,
      { id: coin.id }
    )
  }

  getCoin = () => this.props.coins.find(c => c.id === this.props.coinID)

  isPlatform = (prop) => ['twitter', 'reddit', 'telegram', 'medium', 'discord', 'bitcointalk'].indexOf(prop) >= 0

  saveCoin = () => {
    this.props.saveCoinToDB( _.omitBy( this.state, i => !i ))
    this.props.closeModal()
  }

  getDeletedPastStart = (platform) =>
    this.state.deletedPast[platform] && this.state.deletedPast[platform].split('-')[0]

  getDeletedPastEnd = (platform) =>
    this.state.deletedPast[platform] && this.state.deletedPast[platform].split('-')[0]

  updateDeletedPast = (platform, value) => {
    this.setState({
      deletedPast: { ...this.state.deletedPast, [platform]: value }
    })
  }

  updateSkips = (platform, value) => {
    this.setState({
      skips: { ...this.state.skips, [platform]: value }
    })
  }


  render() {

    const { closeModal } = this.props
    const { apiSymbol, deletedPast, skips } = this.state

  	return(
  		<SModal.Main onClose={closeModal} title='EDIT COIN' >
  			<SModal.Body>
            <fb className="mainEditCoinModal">
              <fb className="editContent">
                { this.coinProps.map(prop =>
                    <fb className='row' key={prop}>
                      <fb className='label'>{prop}</fb>
                      <input type='text' className="input" value={this.state[prop]} onChange={(e) => { this.setState({ [prop]: e.target.value }) }} />
                      { this.isPlatform(prop) &&
                        <fb data-balloon="format: 29383383-22283829 , or: 29383383- , or: -29383383 [unixtime]">
                          <input
                            type='text'
                            className="input"
                            placeholder='disabled interval'
                            value={(deletedPast[prop] || '')}
                            onChange={(e) => this.updateDeletedPast(prop, e.target.value) }
                          />
                        </fb>
                      }
                      { this.isPlatform(prop) &&
                        <fb data-balloon="format: 29383383 or: 29383383,22283829 [unixtime]">
                          <input
                            type='text'
                            className="input"
                            placeholder='unixtimes to skip'
                            value={(skips[prop] || '')}
                            onChange={(e) => this.updateSkips(prop, e.target.value) }
                          />
                        </fb>
                      }
                    </fb>
                  )
                }
              </fb>
  				</fb>
  			</SModal.Body>
  			<SModal.Footer>
  				 {<SButton label='close' onClick={closeModal} mini right />}
  					<SButton color='green' label='save' onClick={apiSymbol && this.saveCoin} mini />
  			</SModal.Footer>
  		</SModal.Main>
  	)
  }
}

const actionsToProps = {
  saveCoinToDB
}

const mapStateToProps = (state: Store) => ({
  coins: coinsExtended(state)
})

export default connect(mapStateToProps, actionsToProps) (EditCoinPopup)



// WEBPACK FOOTER //
// ./src/modals/editCoinPopup/index.js